import { hasSearchParams, saveSearchParams, getSearchParam } from "./document";
import { clearAllSearchParams as clearSessionSearchParams, sessionStore } from "../stores/session";
import { isDemoMode, setMode } from "../stores/mode";
import { setPresetScenario } from "./editor/scenario";
import { setApiUtils, setPollerUtils, setStatusHandler } from "../stores/buildContext";
import { get } from "svelte/store";
import { navigateToPath } from "../routing";
import PATHS from "../constants/routePaths";
import { UnsuccessfulError } from "../public/lib/api/utils";
import { updateSurvey } from "../stores/survey";

// FIXME: Because the router we use doesn't handle the query params properly, we need to save them before it loads
// Reloading the page, retaining the same session, should retain the query params, so we should only replace if
// there are new ones being passed in or on the root path.
// The reasoning behind the route path clearing is so we reduce the side effects for clients testing then participating
// and users in complext multiple order campaigns.
const setupSearchParams = () => {
  if (hasSearchParams() || document.location.pathname === "/") {
    clearSessionSearchParams();
  }
  
  saveSearchParams();
};

const setupModes = () => {
  const modeParam = getSearchParam("👷");

  if (modeParam === "📝") {
    setMode("editor");
  }

  if (modeParam === "🛠") {
    setMode("demo");

    const presets = getSearchParam("presets");
    if (presets && presets.length) {
      const presetList = presets.split(",");
      presetList.forEach((preset) => setPresetScenario(preset));
    }
  }

  if (modeParam === "🤓") {
    setMode("test");
  }
};

export const setupApiUtils = () => {
  setApiUtils({
    handleError: (error: unknown, options: { skipAllErrorHandling?: boolean }) => {
      console.error("There was a problem while trying to fetch: ", error);
      const { skipAllErrorHandling } = options;

      if (!skipAllErrorHandling && !(error instanceof UnsuccessfulError)) {
        navigateToPath(PATHS.ERROR);
      }
      throw error;
    },
    getPersistedJwt: () => get(sessionStore).jwt ?? null
  });
}

export const setupStatusHandler = () => {
  setStatusHandler({
    resetSurvey: () => updateSurvey({ isComplete: false })
  });
}

export const SetupHelpers = {
  setupSearchParams,
  setupModes,
  setupStatusHandler
}

export const setup = () => {
  SetupHelpers.setupSearchParams();
  SetupHelpers.setupModes();
  SetupHelpers.setupStatusHandler();

  if (isDemoMode()) {
    setPollerUtils({ getDelay: () => 0 });
  }

  setupApiUtils();
};
